/* New department menu behavior (loaded only when department_menu_column entries exist).
   1. Priority+ bar: departments that do not fit the row move, as the same DOM nodes, under a
      "More" dropdown (so their lazy panels and listeners keep working). Measured on load,
      on resize (debounced 150ms) and when fonts finish loading. Without JS the row scrolls.
   2. Keyboard: Left/Right arrows move between bar items, Down opens a panel and focuses its
      first link, Escape closes and returns focus to the item that opened it.
   3. Phone drawer: keeps aria-expanded in sync when the accordion closes a sibling.
   Vanilla JS, no dependencies. */
(function () {
  var list = document.querySelector('[data-priority-nav]');
  if (!list) return;

  var more = list.querySelector('[data-more]');
  var moreList = more ? more.querySelector('[data-more-list]') : null;
  var moreDetails = more ? more.querySelector('details') : null;
  var items = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-priority-item]'));

  function fits() {
    return list.scrollWidth <= list.clientWidth + 1;
  }

  function closeOpenPanels() {
    document.querySelectorAll('.department-bar details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector(':scope > summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function layout() {
    if (!more || !moreList) return;
    if (!list.clientWidth) return; /* bar hidden (compact sticky header): keep the last layout */
    items.forEach(function (li) {
      if (li.parentNode !== list) {
        list.insertBefore(li, more);
      }
    });
    more.hidden = true;
    if (fits()) return;
    closeOpenPanels();
    more.hidden = false;
    /* move from the end until the row (including the More button) fits; always keep the first item */
    for (var i = items.length - 1; i > 0 && !fits(); i--) {
      moreList.insertBefore(items[i], moreList.firstChild);
    }
    if (moreList.children.length === 0) more.hidden = true;
  }

  list.classList.add('is-priority');
  layout();

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(layout, 150);
  }
  if ('ResizeObserver' in window) {
    new ResizeObserver(schedule).observe(list);
  } else {
    window.addEventListener('resize', schedule);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  if (moreDetails) {
    moreDetails.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!moreDetails.contains(document.activeElement)) {
          moreDetails.removeAttribute('open');
          var s = moreDetails.querySelector(':scope > summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------- keyboard ---------- */
  function barStops() {
    return Array.prototype.slice.call(list.querySelectorAll(
      ':scope > li:not([hidden]) > header-menu > details > summary, :scope > li:not([hidden]) > a, :scope > li.dept-more:not([hidden]) > details > summary'
    ));
  }

  list.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    var stops = barStops();
    var index = stops.indexOf(target);
    if (index === -1) return; /* only when the item itself has focus, never inside a panel */

    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      var next = stops[(index + (event.key === 'ArrowRight' ? 1 : -1) + stops.length) % stops.length];
      if (next) next.focus();
    } else if (event.key === 'ArrowDown' && target.tagName === 'SUMMARY') {
      event.preventDefault();
      var details = target.parentNode;
      details.setAttribute('open', '');
      target.setAttribute('aria-expanded', 'true');
      var focusFirst = function () {
        var first = details.querySelector('.mega-link, .dept-more__list .header__menu-item');
        if (first) first.focus();
      };
      if (details.querySelector('[data-lazy-menu]')) {
        document.addEventListener('lazy-menu:loaded', function () { setTimeout(focusFirst, 0); }, { once: true });
      } else {
        setTimeout(focusFirst, 0);
      }
    }
  });

  /* Escape: close, then put focus back on the bar item that owned the panel (capture: runs before the close handler) */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var owner = event.target && event.target.closest ? event.target.closest('.department-bar [data-priority-nav] > li') : null;
    if (!owner) return;
    var summary = owner.querySelector('summary');
    if (!summary) return;
    var wasOpen = owner.querySelector('details[open]');
    if (!wasOpen) return;
    setTimeout(function () { summary.focus(); }, 0);
  }, true);
})();

/* Phone drawer: the department accordion is exclusive (details name="drawer-department");
   keep each summary's aria-expanded true to the real state. */
document.addEventListener('toggle', function (event) {
  var d = event.target;
  if (!d || !d.matches || !d.matches('details.menu-drawer__department--v2')) return;
  var s = d.querySelector(':scope > summary');
  if (s) s.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
}, true);
